<template>
  <component :is="layoutFontType" :style="generateStyle" :class="containerClass" @click="$emit('click')">
    <slot />
  </component>
</template>

<script lang="ts">
import type { CSSProperties, PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import type { GameQuizAnswerState, GameQuizQuestionState } from '@/src/components/games/quiz/Model';
import { AnswerFontTypes, AnswerValidationTypes } from '@/src/models/settings/AnswerLayoutSettingsModel';

export default defineComponent({
  name: 'AnswerTextItemsItem',
  props: {
    question: {
      type: Object as PropType<GameQuizQuestionState>,
      required: true
    },
    answer: {
      type: Object as PropType<GameQuizAnswerState>,
      required: true
    },
    showCorrectAnswer: {
      type: Boolean,
      required: true
    },
    selectedAnswers: {
      type: Object as PropType<GameQuizAnswerState[]>,
      required: true
    }
  },
  emits: ['click'],
  setup(props) {
    const layoutFontType = computed(() => {
      switch (props.question.answerLayout.state.fontType) {
        case AnswerFontTypes.P:
          return 'p';
        case AnswerFontTypes.H2:
          return 'h2';
        case AnswerFontTypes.H3:
          return 'h3';
        case AnswerFontTypes.H5:
          return 'h5';
        case AnswerFontTypes.H6:
          return 'h6';
        default:
          return 'h4';
      }
    });

    const containerClass = computed(() => {
      if (props.showCorrectAnswer) {
        if (!props.question.correctAnswers.includes(props.answer.id) && props.selectedAnswers.includes(props.answer)) {
          return {
            'question__answer-item--wrong': true
          };
        }

        if (props.question.correctAnswers.includes(props.answer.id)) {
          return {
            'question__answer-item--correct': true
          };
        }
      }

      return '';
    });

    const generateStyle = computed<CSSProperties>(() => {
      let style: CSSProperties | undefined;
      if (props.showCorrectAnswer) {
        props.selectedAnswers.forEach((selectedAnswer) => {
          if (props.question.correctAnswers.includes(props.answer.id)) {
            if (props.question.answerLayout.state.validationType === AnswerValidationTypes.CONTAINER) {
              style = {
                backgroundColor: `${props.question.answerColor?.correct} !important`
              };
            } else {
              style = {
                color: `${props.question.answerColor?.correct} !important`
              };
            }
          }
          if (selectedAnswer.id === props.answer.id) {
            if (!props.question.correctAnswers.includes(props.answer.id)) {
              if (props.question.answerLayout.state.validationType === AnswerValidationTypes.CONTAINER) {
                style = {
                  backgroundColor: `${props.question.answerColor?.wrong} !important`
                };
              } else {
                style = {
                  color: `${props.question.answerColor?.wrong} !important`
                };
              }
            }
          }
        });
      }
      return style ?? {};
    });

    return {
      containerClass,
      generateStyle,
      layoutFontType
    };
  }
});
</script>
